import React from 'react'
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';
import Dropzone from "react-dropzone";
import {Grid, Typography} from "@mui/material";
import {Trans} from "@lingui/macro";


interface CustomDropzoneUploadDocumentProps {
    callback: (data: File) => void
    text: string
}

interface CustomDropzoneUploadDocumentState {
    documentName: string | null
}

export class CustomDropzoneUploadDocument extends React.Component<CustomDropzoneUploadDocumentProps, CustomDropzoneUploadDocumentState>
{

    constructor(props: CustomDropzoneUploadDocumentProps) {
        super(props)
        this.state = {
            documentName: null
        }
    }

    private onDrop = (acceptedFiles: File[]) => {


        this.setState(() => ({
            documentName: acceptedFiles[0].name,
        }), () => this.props.callback(acceptedFiles[0] as File))
    }

    render () {
        return (
            <Dropzone onDrop={this.onDrop}
            >
                {({getRootProps, getInputProps}) => (
                    <section>
                        <div {...getRootProps()}>
                            <input {...getInputProps()} />
                            <Grid container sx={{display: "grid", border: "2px dashed", paddingX: 2, paddingY: 3 }}>
                                <Grid item xs={12} sx={{alignSelf: "center", justifySelf: "center"}}>
                                    <UploadFileRoundedIcon sx={{fontSize: "6rem", color: "secondary.main"}}/>
                                </Grid>
                                { this.state.documentName === null &&
                                    <Grid item xs={12} sx={{alignSelf: "center", justifySelf: "center"}}>
                                        <Trans id={this.props.text}>
                                        </Trans>
                                    </Grid>
                                }
                                { this.state.documentName !== null &&
                                    <Grid item xs={12} sx={{alignSelf: "center", justifySelf: "center"}}>
                                        <Typography>
                                            {this.state.documentName}
                                        </Typography>
                                    </Grid>
                                }
                            </Grid>
                        </div>
                    </section>
                )}
            </Dropzone>
        )
    }
}
